import styled from 'styled-components';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

export const ItemContainer = styled.div`
    width: 100%;
`;

export const ShortName = styled.span`
    width: 100%;
    ${FONTS.sans.regular.size17};
`;